import { useLocation, useNavigate } from "react-router-dom";
import "../css/cardView.css";

const CardView = () => {
  const navigate = useNavigate();
  const { state = {} } = useLocation();
  const {
    title = "Details",
    gallery = [],
    location = "Location not specified",
    description = "No description available.",
  } = state;

  const images = Array.isArray(gallery) ? gallery.filter(Boolean) : [];

  if (!images.length) {
    return (
      <main className="cardViewContent">
        <div>
          <h1 className="title">{title}</h1>
          <p className="cardViewDescription">No gallery images are available.</p>
          <button type="button" onClick={() => navigate(-1)}>
            Go Back
          </button>
        </div>
      </main>
    );
  }

  return (
    <main>
      <h1 className="title">{title}</h1>

      <div className="cardViewContainer">
        <div className="gallery">
          {images.map((src, index) => (
            <div
              key={`${src}-${index}`}
              className={`gallery-item ${index === 0 ? "tall" : ""}`}
              style={{ backgroundImage: `url(${src})` }}
            />
          ))}
        </div>
      </div>

      <div className="cardViewContent">
        <div>
          <h4 className="title">{location}</h4>
          <p className="cardViewDescription">{description}</p>
        </div>
        <div>
          <input type="date" aria-label="Select date" />
        </div>
      </div>
    </main>
  );
};

export default CardView;
